export type HeaderData = {
    heading: string;
    slug: string;
};

export const headerTopCategoriesData: Array<HeaderData> = [
    {
        heading: 'Barn',
        slug: '/kategori/barn',
    },
    {
        heading: 'Nyheter',
        slug: '/kategori/nyheter',
    },
    {
        heading: 'Sport',
        slug: '/kategori/sport',
    },
    {
        heading: 'Serier',
        slug: '/kategori/serier',
    },
    {
        heading: 'Filmer',
        slug: '/kategori/filmer',
    },
    {
        heading: 'Dokumentär',
        slug: '/kategori/dokumentar',
    },
    {
        heading: 'Drama',
        slug: '/kategori/drama',
    },
    {
        slug: '/teckensprak',
        heading: 'Teckenspråk',
    },
    {
        slug: '/syntolkat',
        heading: 'Syntolkat',
    },
];

export const headerAllCategoriesEditorialData: Array<HeaderData> = [
    {
        heading: 'Serier',
        slug: '/kategori/serier',
    },
    {
        heading: 'Dokumentär',
        slug: '/kategori/dokumentar',
    },
    {
        heading: 'Humor',
        slug: '/kategori/humor',
    },
    {
        heading: 'Barn',
        slug: '/kategori/barn',
    },
    {
        heading: 'Nyheter',
        slug: '/kategori/nyheter',
    },
    {
        heading: 'Sport',
        slug: '/kategori/sport',
    },
    {
        heading: 'Filmer',
        slug: '/kategori/filmer',
    },
    {
        heading: 'Underhållning',
        slug: '/kategori/underhallning',
    },
    {
        heading: 'Livsstil & reality',
        slug: '/kategori/livsstil-och-reality',
    },
    {
        heading: 'Fakta',
        slug: '/kategori/fakta',
    },
    {
        heading: 'Drama',
        slug: '/kategori/drama',
    },
    {
        heading: 'Kultur',
        slug: '/kategori/kultur',
    },
    {
        heading: 'Musik',
        slug: '/kategori/musik',
    },
    {
        heading: 'Samhälle',
        slug: '/kategori/samhalle',
    },
    {
        heading: 'Djur & natur',
        slug: '/kategori/djur-och-natur',
    },
    {
        heading: 'Scen',
        slug: '/kategori/scen',
    },
    {
        heading: 'Öppet arkiv',
        slug: '/kategori/oppet-arkiv',
    },
    {
        slug: '/teckensprak',
        heading: 'Teckenspråk',
    },
    {
        slug: '/syntolkat',
        heading: 'Syntolkat',
    },
];
export const headerAllCategoriesAlphabeticalData: Array<HeaderData> = [
    {
        heading: 'Barn',
        slug: '/kategori/barn',
    },
    {
        heading: 'Dokumentär',
        slug: '/kategori/dokumentar',
    },
    {
        heading: 'Drama',
        slug: '/kategori/drama',
    },
    {
        heading: 'Djur & natur',
        slug: '/kategori/djur-och-natur',
    },
    {
        heading: 'Fakta',
        slug: '/kategori/fakta',
    },
    {
        heading: 'Filmer',
        slug: '/kategori/filmer',
    },
    {
        heading: 'Humor',
        slug: '/kategori/humor',
    },
    {
        heading: 'Kultur',
        slug: '/kategori/kultur',
    },
    {
        heading: 'Livsstil & reality',
        slug: '/kategori/livsstil-och-reality',
    },
    {
        heading: 'Musik',
        slug: '/kategori/musik',
    },
    {
        heading: 'Nyheter',
        slug: '/kategori/nyheter',
    },
    {
        heading: 'Serier',
        slug: '/kategori/serier',
    },
    {
        heading: 'Samhälle',
        slug: '/kategori/samhalle',
    },
    {
        heading: 'Scen',
        slug: '/kategori/scen',
    },
    {
        heading: 'Sport',
        slug: '/kategori/sport',
    },

    {
        heading: 'Underhållning',
        slug: '/kategori/underhallning',
    },

    {
        heading: 'Öppet arkiv',
        slug: '/kategori/oppet-arkiv',
    },
    {
        slug: '/teckensprak',
        heading: 'Teckenspråk',
    },
    {
        slug: '/syntolkat',
        heading: 'Syntolkat',
    },
];

export const headerInstrumentalData: Array<HeaderData> = [
    {
        heading: 'Program A-Ö',
        slug: '/program',
    },
    {
        heading: 'Min lista',
        slug: '/min-lista',
    },
    {
        heading: 'Direktsändningar',
        slug: '/direkt',
    },
    {
        heading: 'Populärt',
        slug: '/populara',
    },
    {
        heading: 'Senaste',
        slug: '/senaste',
    },
    {
        heading: 'Sista chansen',
        slug: '/sista-chansen',
    },
];
